// The app chrome a page can ask for. A route that is bare for guests (the
// auth frame: log in, sign up, an invitation) asks for the signed-out top
// bar back while it shows a status page instead, so a dead invitation looks
// like a private session or a missing pack. The ask names its path, so the
// next page never inherits it.
import { reactive } from "vue";

export const guestChrome = reactive({ topBarPath: "" });
